import { Container, Row, Col } from 'reactstrap';
import { useAppContext, useTranslator } from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';

const ConfirmPage = () => {
  const { t, language } = useTranslator();

  const {
    images: {
      appStore,
      googlePlay,
      confirm,
      thankYouPageLogInEn,
      thankYouPageLogInSe,
      thankYouPageLogInPl,
      thankYouPageLogInPt,
      thankYouPageAppSe,
      thankYouPageAppEn,
      thankYouPageAppPl,
      thankYouPageAppPt,
    },
    consts: { GOOGLE_PLAY_URL, APP_STORE_URL },
  } = useAppContext();

  const imageMap = {
    'en-US': {
      logIn: thankYouPageLogInEn,
      enjoyApp: thankYouPageAppEn,
    },
    'sv-SE': {
      logIn: thankYouPageLogInSe,
      enjoyApp: thankYouPageAppSe,
    },
    'pl-PL': {
      logIn: thankYouPageLogInPl,
      enjoyApp: thankYouPageAppPl,
    },
    'pt-BR': {
      logIn: thankYouPageLogInPt,
      enjoyApp: thankYouPageAppPt,
    },
  };

  const renderImage = (name) => imageMap[language]?.[name] || null;

  return (
    <Layout simpleLayout>
      <div className="page-template-confirm">
        <Container className="py-md-4">
          <Row>
            <Col lg={{ size: 6, offset: 3 }}>
              <div className="page-container">
                <div className="thankyou-container">
                  <section>
                    <div className="text-center">
                      <img
                        srcSet={`${confirm} 100w`}
                        sizes="50px"
                        alt=""
                        className="img-fluid mb-xl"
                      />
                    </div>
                    <h1 className="title-large semi-bold text-center mb-xl">
                      {t('app.activationAccount.title')}
                    </h1>
                    <p className="text-center">
                      <span
                        className="text-text-variant-color"
                        dangerouslySetInnerHTML={{
                          __html: t('app.activationAccount.content'),
                        }}
                      ></span>
                    </p>
                  </section>
                  <hr />
                  <section className="instruction">
                    <h2 className="title-medium semi-bold mb-xxl">
                      {t('app.activationAccount.nextStepsHeader')}
                    </h2>
                    <ol>
                      <li>
                        <h3 className="title-medium semi-bold mb-m">
                          {t('app.activationAccount.downloadApp.title')}
                        </h3>
                        <p className="text-text-variant-color">
                          {t('app.activationAccount.downloadApp.description')}
                        </p>
                        <a className="d-inline-block me-l" href={APP_STORE_URL}>
                          <img src={appStore} className="store-btn" alt="App store" />
                        </a>
                        <a className="d-inline-block" href={GOOGLE_PLAY_URL}>
                          <img src={googlePlay} className="store-btn" alt="Google Play" />
                        </a>
                      </li>
                      <li>
                        <h3 className="title-medium semi-bold mb-m">
                          {t('app.activationAccount.signInToApp.title')}
                        </h3>
                        <p
                          className="text-text-variant-color"
                          dangerouslySetInnerHTML={{
                            __html: t('app.activationAccount.signInToApp.description'),
                          }}
                        />

                        <img
                          srcSet={`${renderImage('logIn')} 100w`}
                          sizes="50px"
                          className="img-fluid"
                          alt=""
                        />
                      </li>
                      <li>
                        <h3 className="title-medium semi-bold mb-m">
                          {t('app.activationAccount.enjoyApp.title')}
                        </h3>
                        <p className="text-text-variant-color">
                          {t('app.activationAccount.enjoyApp.description')}
                        </p>
                        <img
                          srcSet={`${renderImage('enjoyApp')} 100w`}
                          sizes="50px"
                          className="img-fluid"
                          alt=""
                        />
                      </li>
                    </ol>
                  </section>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default ConfirmPage;
